import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M18.835 10.5A8.333 8.333 0 1 1 10.5 2.165"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19.636 7.452a9.72 9.72 0 0 0-6.475-6.026l-2.661 9.35z"
    }, null, -1)
  ]))]))
}
export default { render: render }